export interface State {
   activeHttpRequestCount: number;
}

export const initialValues: State = {
   activeHttpRequestCount: 0
};
